import React, { useState } from 'react';
import { Button } from "antd";
import { ResultModal } from "../mythPASSModal/resultModal";
import { Web3Store } from "../../stores/web3Store";
import { getWalletProof } from "../../utils/merkeltree";
import logger from "../../logger";
import { toOpensea } from "../../utils/commonUtils"

interface IProps {
    web3Store: Web3Store,
    activeMenu: any,
    themeId: number,
    nftTypeId: number,
    contractAddress: string,
    mythNftWhiteList: string[],
    isDisable: boolean;
    btnContent:string;
}

export const MintBtn = ({ web3Store, activeMenu, themeId, nftTypeId, contractAddress, mythNftWhiteList, isDisable,btnContent }: IProps) => {
    let [resultVisible, setResultVisible] = useState(false);
    let [resultSuccess, setResultSuccess] = useState(false);
    const toMyNFT = (account: string) => {
        toOpensea(account)
    }
    const mintNFT = async () => {
        try {
            if (web3Store && themeId !== -1 && nftTypeId !== -1 && contractAddress && mythNftWhiteList && web3Store.mythNFTManager) {
                const tx = await web3Store.mythNFTManager?.whitelistClaim(contractAddress, nftTypeId,
                    getWalletProof(web3Store.account, mythNftWhiteList));
                await tx.wait();
                setResultSuccess(true);
                setResultVisible(true);
            }
        } catch (e) {
            setResultSuccess(false);
            setResultVisible(true);
            logger.error(e)
        }
    }
    const resultModalOnCancel = () => {
        setResultVisible(false)
        window.location.reload()
    }
    const renderResult = () => {
        let content,
            text = <>Minting failed <br /> Please try again</>;
        if (resultSuccess) {
            content = <><Button className='myth-button nft-btn'
                onClick={() => toMyNFT(web3Store.account)}>My NFT
                Collections</Button></>

            text = <>Congratulations! < br /> Minted successfully!</>
        }
        return <ResultModal success={resultSuccess} visible={resultVisible} onCancel={resultModalOnCancel}
            content={content} text={text} />
    }
    return <>
        <Button className='myth-button myth-button-success' style={{width:"5.5rem"}} onClick={mintNFT} disabled={isDisable}>{btnContent}</Button>
        {resultVisible && renderResult()}
    </>

}
